const TRANSFER_POLICY_TEXT_LOWER = Object.freeze({
  allTransfers: 'self_employed_all_transfers',
  splitCommissions: 'self_employed_split_commissions',
  tipOnly: 'employed_tip_only',
  noTransfer: 'no_transfers',
});

// noinspection JSUnusedGlobalSymbols
export default TRANSFER_POLICY_TEXT_LOWER;
